'use client'

import { useParams } from 'next/navigation'

import { Box, Pagination } from '@fortum/elemental-ui'

import type { ArticleCategoryProps } from '@/app/[locale]/(open-web)/(with-footer)/blog/[slug]/[page]/page'
import { Link } from '@/i18n/navigation'
import { routes } from '@/shared/routes'

import { ALL_CATEGORIES_SLUG } from '../constants'

export type ArticlePaginationProps = {
  pageCount: number
}

export const ArticlePagination = ({ pageCount }: ArticlePaginationProps) => {
  const params = useParams<Awaited<ArticleCategoryProps['params']>>()

  const page = Number.parseInt(params.page)

  if (pageCount === 1) {
    return null
  }

  const isPageOutOfRange = (pageNumber: number) => {
    return pageNumber > pageCount || pageNumber < 1
  }

  if (isPageOutOfRange(page)) {
    return null
  }

  return (
    <Box display="flex" justifyContent="center">
      <Pagination
        active={page}
        pages={pageCount}
        tag={Link}
        buttonProps={(pageNumber) => ({
          href: isPageOutOfRange(pageNumber)
            ? '#' // Prevents the link from being clickable
            : `${routes.BLOG}/${params.slug || ALL_CATEGORIES_SLUG}/${pageNumber}`,
          style: { display: isPageOutOfRange(pageNumber) ? 'none' : 'flex' },
        })}
      />
    </Box>
  )
}
